// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relatorios-page {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

/* Tabs */
.rel-tabs {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.rel-tab {
    padding: 8px 18px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 20px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 500;
    transition: all 0.2s;
}

.rel-tab:hover {
    border-color: #667eea;
}

.rel-tab.active {
    background: #667eea;
    color: white;
    border-color: #667eea;
}

/* Search */
.rel-search {
    margin-bottom: 20px;
}

.rel-search input {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.95rem;
    box-sizing: border-box;
    background: white;
}

.rel-search input:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15);
}

/* Loading / Empty */
.rel-loading,
.rel-empty {
    text-align: center;
    padding: 40px;
    color: #888;
    font-size: 1rem;
}

/* Desktop Table */
.rel-table-wrapper {
    background: white;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.rel-table {
    width: 100%;
    border-collapse: collapse;
}

.rel-table th {
    background: #f8fafc;
    padding: 12px 14px;
    text-align: left;
    font-size: 0.8rem;
    text-transform: uppercase;
    color: #64748b;
    font-weight: 600;
    border-bottom: 2px solid #e2e8f0;
}

.rel-table td {
    padding: 10px 14px;
    border-bottom: 1px solid #f1f5f9;
    font-size: 0.88rem;
    color: #334155;
}

.rel-table tbody tr:hover {
    background-color: #f8fafc;
}

.rel-num {
    font-weight: 600;
    color: #0056b3;
}

/* Badges */
.rel-tipo-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.tipo-dl50 {
    background: #dbeafe;
    color: #1e40af;
}

.tipo-andaime {
    background: #fef3c7;
    color: #92400e;
}

.rel-resultado {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 10px;
    white-space: nowrap;
}

.rel-resultado.apto {
    background: #d1fae5;
    color: #065f46;
}

.rel-resultado.nao-apto {
    background: #fee2e2;
    color: #991b1b;
}

/* Action buttons in table */
.rel-actions-cell {
    display: flex;
    gap: 6px;
}

.rel-btn {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: white;
    cursor: pointer;
    font-size: 0.95rem;
    transition: all 0.2s;
}

.rel-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.rel-btn-pdf {
    border-color: #dc3545;
}

.rel-btn-pdf:hover {
    background: #dc3545;
    color: white;
}

.rel-btn-share {
    border-color: #25D366;
}

.rel-btn-share:hover {
    background: #25D366;
    color: white;
}

/* Mobile Cards - hidden on desktop */
.rel-cards-mobile {
    display: none;
}

.rel-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.rel-card-top {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

.rel-card-num {
    font-weight: 700;
    color: #0056b3;
    flex: 1 1;
    font-size: 0.9rem;
}

.rel-card-body {
    padding: 8px 14px;
}

.rel-card-body p {
    margin: 3px 0;
    font-size: 0.85rem;
    color: #555;
}

.rel-card-actions {
    display: flex;
    gap: 8px;
    padding: 10px 14px;
    border-top: 1px solid #f0f0f0;
}

.rel-btn-full {
    flex: 1 1;
    padding: 8px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    text-align: center;
    color: white;
    transition: opacity 0.2s;
}

.rel-btn-full:hover {
    opacity: 0.85;
}

.rel-btn-full.rel-btn-pdf {
    background: #dc3545;
}

.rel-btn-full.rel-btn-share {
    background: #25D366;
}

/* Summary */
.rel-summary {
    margin-top: 15px;
    text-align: right;
    font-size: 0.85rem;
    color: #888;
}

/* Responsive - show cards, hide table */
@media (max-width: 768px) {
    .rel-table-wrapper {
        display: none;
    }

    .rel-cards-mobile {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Relatorios.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,WAAW;AACX;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA,oBAAoB;AACpB;;IAEI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA,wCAAwC;AACxC;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".relatorios-page {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100%;\r\n}\r\n\r\n/* Tabs */\r\n.rel-tabs {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-bottom: 20px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.rel-tab {\r\n    padding: 8px 18px;\r\n    border: 1px solid #ddd;\r\n    background: white;\r\n    border-radius: 20px;\r\n    cursor: pointer;\r\n    font-size: 0.85rem;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.rel-tab:hover {\r\n    border-color: #667eea;\r\n}\r\n\r\n.rel-tab.active {\r\n    background: #667eea;\r\n    color: white;\r\n    border-color: #667eea;\r\n}\r\n\r\n/* Search */\r\n.rel-search {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.rel-search input {\r\n    width: 100%;\r\n    padding: 10px 14px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    font-size: 0.95rem;\r\n    box-sizing: border-box;\r\n    background: white;\r\n}\r\n\r\n.rel-search input:focus {\r\n    outline: none;\r\n    border-color: #667eea;\r\n    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15);\r\n}\r\n\r\n/* Loading / Empty */\r\n.rel-loading,\r\n.rel-empty {\r\n    text-align: center;\r\n    padding: 40px;\r\n    color: #888;\r\n    font-size: 1rem;\r\n}\r\n\r\n/* Desktop Table */\r\n.rel-table-wrapper {\r\n    background: white;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.rel-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.rel-table th {\r\n    background: #f8fafc;\r\n    padding: 12px 14px;\r\n    text-align: left;\r\n    font-size: 0.8rem;\r\n    text-transform: uppercase;\r\n    color: #64748b;\r\n    font-weight: 600;\r\n    border-bottom: 2px solid #e2e8f0;\r\n}\r\n\r\n.rel-table td {\r\n    padding: 10px 14px;\r\n    border-bottom: 1px solid #f1f5f9;\r\n    font-size: 0.88rem;\r\n    color: #334155;\r\n}\r\n\r\n.rel-table tbody tr:hover {\r\n    background-color: #f8fafc;\r\n}\r\n\r\n.rel-num {\r\n    font-weight: 600;\r\n    color: #0056b3;\r\n}\r\n\r\n/* Badges */\r\n.rel-tipo-badge {\r\n    padding: 3px 10px;\r\n    border-radius: 12px;\r\n    font-size: 0.75rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.tipo-dl50 {\r\n    background: #dbeafe;\r\n    color: #1e40af;\r\n}\r\n\r\n.tipo-andaime {\r\n    background: #fef3c7;\r\n    color: #92400e;\r\n}\r\n\r\n.rel-resultado {\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n    padding: 2px 8px;\r\n    border-radius: 10px;\r\n    white-space: nowrap;\r\n}\r\n\r\n.rel-resultado.apto {\r\n    background: #d1fae5;\r\n    color: #065f46;\r\n}\r\n\r\n.rel-resultado.nao-apto {\r\n    background: #fee2e2;\r\n    color: #991b1b;\r\n}\r\n\r\n/* Action buttons in table */\r\n.rel-actions-cell {\r\n    display: flex;\r\n    gap: 6px;\r\n}\r\n\r\n.rel-btn {\r\n    width: 34px;\r\n    height: 34px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    background: white;\r\n    cursor: pointer;\r\n    font-size: 0.95rem;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.rel-btn:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.rel-btn-pdf {\r\n    border-color: #dc3545;\r\n}\r\n\r\n.rel-btn-pdf:hover {\r\n    background: #dc3545;\r\n    color: white;\r\n}\r\n\r\n.rel-btn-share {\r\n    border-color: #25D366;\r\n}\r\n\r\n.rel-btn-share:hover {\r\n    background: #25D366;\r\n    color: white;\r\n}\r\n\r\n/* Mobile Cards - hidden on desktop */\r\n.rel-cards-mobile {\r\n    display: none;\r\n}\r\n\r\n.rel-card {\r\n    background: white;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    margin-bottom: 10px;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.rel-card-top {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 10px 14px;\r\n    background: #f8fafc;\r\n    border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n.rel-card-num {\r\n    font-weight: 700;\r\n    color: #0056b3;\r\n    flex: 1;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.rel-card-body {\r\n    padding: 8px 14px;\r\n}\r\n\r\n.rel-card-body p {\r\n    margin: 3px 0;\r\n    font-size: 0.85rem;\r\n    color: #555;\r\n}\r\n\r\n.rel-card-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n    padding: 10px 14px;\r\n    border-top: 1px solid #f0f0f0;\r\n}\r\n\r\n.rel-btn-full {\r\n    flex: 1;\r\n    padding: 8px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n    font-size: 0.85rem;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    color: white;\r\n    transition: opacity 0.2s;\r\n}\r\n\r\n.rel-btn-full:hover {\r\n    opacity: 0.85;\r\n}\r\n\r\n.rel-btn-full.rel-btn-pdf {\r\n    background: #dc3545;\r\n}\r\n\r\n.rel-btn-full.rel-btn-share {\r\n    background: #25D366;\r\n}\r\n\r\n/* Summary */\r\n.rel-summary {\r\n    margin-top: 15px;\r\n    text-align: right;\r\n    font-size: 0.85rem;\r\n    color: #888;\r\n}\r\n\r\n/* Responsive - show cards, hide table */\r\n@media (max-width: 768px) {\r\n    .rel-table-wrapper {\r\n        display: none;\r\n    }\r\n\r\n    .rel-cards-mobile {\r\n        display: block;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
